import * as angular from 'angular';
import { Units } from '../constants/units';

function WithUnitFilter(Abbreviate, Convert, Utils) {
  return (value: number, fromUnitName: string, toUnitName?: string, decimals = 2) => {
    if (!toUnitName) {
      toUnitName = fromUnitName;
    }
    let fromUnit = Units[fromUnitName],
      toUnit = Units[toUnitName];
    let converted = Convert(value, fromUnit).to(toUnit);

    // Not entirely sure if this should truncate or round
    converted[toUnit] = Utils.truncate(converted[toUnit], decimals);
    let result = `${converted[toUnit]} ${Abbreviate(toUnit)}`;

    return result;
  };
}

angular.module('ciApp').filter('withUnit', ['Abbreviate', 'Convert', 'Utils', WithUnitFilter]);



// WEBPACK FOOTER //
// ./common/filters/with-unit.filter.ts